import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { EnumService } from "../services/enum.service";
import { MatDialog } from "@angular/material";
import { FilialDialogComponent } from "../../shop/Filial/filial-dialog/filial-dialog.component";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-categories-menu",
  templateUrl: "./categories-menu.component.html",
  styleUrls: ["./categories-menu.component.sass"],
})
export class CategoriesMenuComponent implements OnInit {
  constructor(
    private route: Router,
    private enumService: EnumService,
    private router: Router,
    private dialog: MatDialog
  ) { }
  categoryList: any[] = [];
  categoryList2: any[] = [];
  ngOnInit() {
    this.getMenu();
    this.categoryList = [
      {
        icono: "videogame_asset",
        categoryName: "Zona Gamer",
        categoryCode: "/home/products/all",
      },
    ];
  }
  irACategory(item) {
    // if (item.icono == "dehaze") {
    //   alert("por el momento no disponible");
    //   return;
    // }
    if (sessionStorage.getItem("paramFilter") != null) {
      let paramNomItem = {
        param1: "",
        param2: "",
        param3: "",
      };
      sessionStorage.setItem("paramFilter", JSON.stringify(paramNomItem));
    }
    sessionStorage.setItem("marca", "TODAS");
    if (item.icono == "videogame_asset") {
      this.router.navigate(["/home/products", 0, 0, "gamer", "TODAS", 0, 0, 1]);
      this.enumService.setTitleMeta(item.categoryName + " | Novaplaza", {
        name: "description",
        content:
          "Ofrecemos las mejores " +
          item.categoryName +
          " al mejor precio en Arequipa",
      });
      return;
    }
    this.router.navigate([
      "/home/products",
      item.categoryCode,
      0,
      0,
      "TODAS",
      0,
      0,
      1,
    ]);
    this.enumService.setTitleMeta(item.categoryName + " | Novaplaza", {
      name: "description",
      content:
        "Ofrecemos las mejores " +
        item.categoryName +
        " al mejor precio en Arequipa",
    });
  }
  getMenu() {
    this.enumService.getMenu("SBC").subscribe((res: any) => {
      ////console.log(res[0].menusECat_List);
      if (res.length > 0) {

        res[0].menusECat_List.forEach((el) => {
          this.categoryList.push({
            icono: el.IconMenuECat,
            categoryName: el.DenoCat,
            categoryCode: el.Codigo,
          });
        });
      }
      // console.log(this.categoryList)
    });
  }
  public openProductDialog() {
    let dialogRef = this.dialog.open(FilialDialogComponent, {
      data: null,
      panelClass: "product-dialog",
      width: "850px",
    });
  }
}
